import { createSelector } from '@ngrx/store';
import { AppState } from '../../app.state';
import {
  canAccessModule,
  canDo,
  hasPermission,
} from './permissions.catalog';
import { PermissionsState } from './permissions.reducer';

export const selectPermissionsState = (state: AppState): PermissionsState =>
  state.permissions;

export const selectPermissions = createSelector(
  selectPermissionsState,
  (state: PermissionsState) => state.permissions
);

export const selectPermissionsLoaded = createSelector(
  selectPermissionsState,
  (state: PermissionsState) => state.loaded
);

export const selectHasPermission = (permissionName: string) =>
  createSelector(selectPermissions, (permissions: string[]) =>
    hasPermission(permissions, permissionName)
  );

export const selectCanAccessModule = (moduleName: string) =>
  createSelector(
    selectPermissions,
    (permissions: string[]) => canAccessModule(permissions, moduleName)
  );

export const selectCanDo = (moduleName: string, action = 'access') =>
  createSelector(
    selectPermissions,
    (permissions: string[]) => canDo(permissions, moduleName, action)
  );

export const selectHasOwnDataScope = (moduleName: string) =>
  createSelector(selectPermissions, (permissions: string[]) =>
    hasPermission(permissions, `own_data:${moduleName}`)
  );
